import { render, staticRenderFns } from "./GerenciarAvisosPage.vue?vue&type=template&id=3cff6e4a&scoped=true"
import script from "./GerenciarAvisosPage.vue?vue&type=script&lang=js"
export * from "./GerenciarAvisosPage.vue?vue&type=script&lang=js"
import style0 from "./GerenciarAvisosPage.vue?vue&type=style&index=0&id=3cff6e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cff6e4a",
  null
  
)

export default component.exports